module.exports = __webpack_public_path__ + "static/media/file.031772cb.svg";